import comp from "./LearningGoalsRating";
export default comp;
